import * as FiIcons from 'react-icons/fi'
import {
  PiFileText, PiShoppingCartSimple, PiReceipt, PiUsers, PiPercent, PiBriefcase, PiStorefront,
  PiTag, PiWarehouse, PiPackage, PiTruck, PiTrendUp, PiSlidersHorizontal,
  PiCalculator, PiTrendDown, PiArrowUUpLeft, PiRepeat, PiPiggyBank, PiHandshake, PiChartBar, PiUserGear,
  PiHardHat, PiBuildings, PiCompassTool, PiNotebook
} from 'react-icons/pi'

// Icon set (Feather via react-icons, project-wide convention)
export const iconMap = {
  FaBoxes: FiIcons.FiPackage,
  FaTruck: FiIcons.FiTruck,
  FaUsers: FiIcons.FiUsers,
  FaFileInvoice: FiIcons.FiFileText,
  FaChartLine: FiIcons.FiTrendingUp,
  FaCog: FiIcons.FiSettings,
  FaBuilding: FiIcons.FiHome,
  FaClipboardList: FiIcons.FiClipboard,
  FaMoneyBillWave: FiIcons.FiDollarSign,
  FaUserTie: FiIcons.FiUser,
  FaWarehouse: FiIcons.FiArchive,
  FaPercent: FiIcons.FiPercent,
  FaHandshake: FiIcons.FiShoppingCart,
  FaPeopleCarry: FiIcons.FiUsers,
  FaWallet: FiIcons.FiDollarSign,
  FaBox: FiIcons.FiPackage,
  FaToolbox: FiIcons.FiTool,
  FaHandHoldingUsd: FiIcons.FiDollarSign,
  FaUser: FiIcons.FiUser,
  FaPeopleArrows: FiIcons.FiUsers,
  FaCity: FiIcons.FiHome,
  FaProjectDiagram: FiIcons.FiGitBranch,
  FaCube: FiIcons.FiBarChart2,
  FaCarCrash: FiIcons.FiAlertCircle,
  FaFileInvoiceDollar: FiIcons.FiFileText,
  FaRegQuestionCircle: FiIcons.FiHelpCircle,
  FaMoneyBill: FiIcons.FiDollarSign,
  FaListOl: FiIcons.FiList,
  FaPencilAlt: FiIcons.FiEdit,
  FaTools: FiIcons.FiTool,
  FaGripVertical: FiIcons.FiGrid,
  FaShoppingCart: FiIcons.FiShoppingCart,
  default: FiIcons.FiFolder
}

// Moduli raggiungibili solo dal dropdown avatar (NavbarObj) — non servono come tile in Home o voce in Sidebar.
export const HIDDEN_FROM_GRID = ['Settaggi']

// Icona per titolo sezione (una diversa per ognuna): il campo `icon` in Mongo ha troppi doppioni
// una volta mappato su Feather. `icon` resta solo come fallback per sezioni nuove non ancora qui.
export const SEZIONE_ICONS = {
  Preventivi: PiFileText,
  Ordini: PiShoppingCartSimple,
  Fatture: PiReceipt,
  Clienti: PiUsers,
  Sconti: PiPercent,
  Servizi: PiBriefcase,
  'E-commerce': PiStorefront,
  Articoli: PiTag,
  Magazzino: PiWarehouse,
  Scatole: PiPackage,
  Fornitori: PiTruck,
  Ricarico: PiTrendUp,
  Variabili: PiSlidersHorizontal,
  'Contabilità': PiCalculator,
  Costi: PiTrendDown,
  Rimborsi: PiArrowUUpLeft,
  Canoni: PiRepeat,
  Investimenti: PiPiggyBank,
  Investitori: PiHandshake,
  Analisi: PiChartBar,
  Utenti: PiUserGear,
  Cantieri: PiHardHat,
  Costruzioni: PiBuildings,
  Progetti: PiCompassTool,
  Resoconti: PiNotebook
}

export function getSezioneIcon (sezione) {
  return SEZIONE_ICONS[sezione.title] || iconMap[sezione.icon] || iconMap.default
}
